// @note GRWTH-5329 is the task to support pulling in GROW articles from REST endpoint in Zesty. That will make this content dynamic.

const P1 =
  'When you make a purchase with your Acorns Visa™ debit card or another linked card, Acorns rounds up your transaction to the nearest dollar and invests the change into your Invest account portfolio.'
const P2 =
  'Real-time Round-Ups from your Acorns Visa™ debit card are pulled from your Spend account and are invested into your Invest account as soon as your transaction clears. This gives your money the chance to start growing right away.'
const P3 =
  "Round-Ups made from other linked cards are tracked by Acorns until they hit at least $5 in total and then are automatically transferred as one Round-Ups transaction into your Acorns Invest account.  This money is always transferred from the bank account you've indicated as your funding source."
const P4 =
  "Please ensure you maintain enough money in your funding source account to cover your Round-Ups.  Your funding source bank may charge you overdraft fees if you don't have enough funds.\n\n"
const P5 = 'The average Acorns user invests more than $30 a month through our Round-Ups® feature '

const MoreInfoPrompt = {
  title: 'Round-Ups®',
  subtitle: 'What are Round-Ups®',
  message: [P1, P2, P3, P4, P5],
}

export { MoreInfoPrompt }
